import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { api } from './api.js';
import Login from './pages/Login.jsx';
import Picker from './pages/Picker.jsx';
import Project from './pages/Project.jsx';
import Dossier from './pages/Dossier.jsx';
import Nav from './components/Nav.jsx';
import CommandBar from './components/CommandBar.jsx';
import InitiationModal from './components/InitiationModal.jsx';

export default function App() {
  const [status, setStatus] = useState({ loading: true });
  useEffect(() => { refresh(); }, []);
  async function refresh() {
    try {
      const s = await api('/api/auth/status');
      setStatus({ loading: false, ...s });
    } catch {
      setStatus({ loading: false, initialized: false, authenticated: false });
    }
  }

  if (status.loading) return <div style={{ padding: 40 }}></div>;
  if (!status.initialized) {
    return (
      <div style={{ padding: 40, fontFamily: 'var(--font-sans)', fontStyle: 'italic' }}>
        The workshop is not yet sealed. Visit <a href="/workshop-seed" style={{ color: 'var(--ink)' }}>the seeder</a> to set the password.
      </div>
    );
  }
  if (!status.authenticated) return <Login onAuthed={refresh} />;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Nav project={null} />
            <CommandBar project={null} />
            <InitiationModal project={null} />
            <Picker />
          </>
        }
      />
      <Route path="/project/:projectId/*" element={<ProjectRouteLayout />} />
      <Route path="/dossier/:dossierId" element={<><Nav project={null} /><CommandBar project={null} /><InitiationModal project={null} /><Dossier /></>} />
      <Route path="/thread/:threadId/*" element={<ThreadDeepLink />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function ProjectRouteLayout() {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    api(`/api/projects/${projectId}`)
      .then(setProject)
      .catch(() => setProject(false));
  }, [projectId]);

  if (project === false) return <div style={{ padding: 40 }}>Project not found.</div>;
  if (!project) return null;

  return (
    <>
      <CommandBar project={project} />
      <InitiationModal project={project} />
      <Project />
    </>
  );
}

// ThreadDeepLink — /thread/:threadId resolves the thread's project, then renders
// the Desk shell with the drawer open on that thread. Keeps deep links working.
function ThreadDeepLink() {
  const { threadId } = useParams();
  const [thread, setThread] = useState(null);
  const [project, setProject] = useState(null);

  useEffect(() => {
    let ok = true;
    api(`/api/threads/${threadId}`)
      .then(async t => {
        if (!ok) return;
        setThread(t);
        const p = await api(`/api/projects/${t.projectId}`);
        if (ok) setProject(p);
      })
      .catch(() => { if (ok) setThread(false); });
    return () => { ok = false; };
  }, [threadId]);

  if (thread === false) return <div style={{ padding: 40 }}>Thread not found.</div>;
  if (!thread || !project) return null;

  return (
    <>
      <CommandBar project={project} />
      <InitiationModal project={project} />
      <Project projectId={thread.projectId} initialThreadId={threadId} />
    </>
  );
}
